import { ReactElement, useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Chip, FormControl, Input, InputLabel, MenuItem } from "@mui/material";
import Select  from "@mui/material/Select";

interface IFilterDialogProps {
  handleClose: () => void;
  onHandleAccept: (filter: string[]) => void;
  keys: string[];
  currentFilter: string[];
  open: boolean;
  property: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  slotProps: {
    paper: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  },
};

const FilterDialog = ({ open, handleClose, onHandleAccept, keys, currentFilter, property }: IFilterDialogProps): ReactElement => {
  const [filter, setFilter] = useState<string[]>( [] );

  useEffect(() => {
    setFilter(currentFilter);
  }, [ currentFilter ]);

  const onHandleReset = () => {
    setFilter([]);
  };

  return(
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Filter</DialogTitle>
      <DialogContent dividers={true}>
        <FormControl sx={{ minWidth: 300, maxWidth: 300 }}>
          <InputLabel id="demo-mutiple-chip-label">{property}</InputLabel>
          <Select
            variant="standard"
            labelId="demo-mutiple-chip-label"
            id="demo-mutiple-chip"
            multiple={true}
            value={filter}
            onChange={event => setFilter(event.target.value as string[])}
            input={<Input id="select-multiple-chip" />}
            renderValue={(item) =>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {(item as string[]).map((value) => <Chip key={`item-${value}`} label={value} sx={{ margin: 2 }} />)}
              </div>
            }
            MenuProps={MenuProps}>
            {keys.map((name) => <MenuItem key={name} value={name}>{name}</MenuItem>)}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onHandleAccept(filter)} color="primary" variant="contained" >
          Accept
        </Button>
        <Button onClick={onHandleReset} className="neutral-value" variant="contained" >
          Reset
        </Button>
        <Button onClick={handleClose} color="secondary" variant="contained" >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilterDialog;
